import { render, staticRenderFns } from "./UserBoughtLessonList.vue?vue&type=template&id=605e1671"
import script from "./UserBoughtLessonList.vue?vue&type=script&lang=js"
export * from "./UserBoughtLessonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports